import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography, Chip, Skeleton } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";

import CommonButton from "../../Components/InputComponents/CommonButton";
import HorizontalStageBox from "./Components/HorizontalStageBox";


// Example loader
const StagesSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        overflowX: "auto",
        padding: 1,
      }}
    >
      {Array.from({ length: rows }).map((_, stageIndex) => (
        <Box
          key={stageIndex}
          sx={{
            minWidth: "300px",
            borderRadius: 3,
            p: 2,
            m: 1,
            mt: 3,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.49)",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {/* Header icon */}
          <Skeleton
            variant="circular"
            width={30}
            height={30}
            sx={{ mb: 1 }}
          />

          {/* Header text */}
          <Skeleton
            variant="rectangular"
            width="60%"
            height={20}
            sx={{ borderRadius: 1, mb: 1 }}
          />

          {/* Procedure Title */}
          <Skeleton
            variant="rectangular"
            width="80%"
            height={25}
            sx={{ borderRadius: 1, mb: 1 }}
          />

          {/* Sub-procedures */}
          {Array.from({ length: columns }).map((_, subIndex) => (
            <Box
              key={subIndex}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
                borderLeft: "4px solid #E0E0E0",
                borderRadius: 1,
                p: 1,
              }}
            >
              <Skeleton
                variant="circular"
                width={30}
                height={30}
              />
              <Skeleton
                variant="rectangular"
                width={150}
                height={20}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};


function CandidateJobs() {
  const Navigate = useNavigate();

  const {candidateJobData } = useCandidateLayout(); 
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    if (candidateJobData) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [candidateJobData]);

  return (
    <Box
      sx={{
        p: 4,
        mx: "auto",
        margin: "auto",
        padding: "20px",
        maxWidth: `100vw`,
      }}
    >
      <CommonButton
        background="#006CB8"
        textColor="white"
        onClick={() => Navigate(`/`)}
        sx={{
          minWidth: "100px",
          color: "white",
          mt: 0.5,
          borderRadius: "20px",
          height: "30px",
          textTransform: "capitalize",
        }}
      >
        Back
      </CommonButton>

      <Typography
        sx={{
          fontFamily: "Geist, sans-serif",
          fontSize: { xs: "16px", sm: "18px", lg: "22px" },
          fontWeight: 700,
          margin: "10px auto",
        }}
      >
        Jobs
      </Typography>

      {/* Job Procedure Mapping */}
      <Grid container>
        {loading
          ? Array.from({ length: 5 }).map((_, index) => (
            <StagesSkeleton />
          ))
          : candidateJobData?.length ? candidateJobData?.map((job, index) => {
            const jobTitle = job?.JD_Title;
            const jobId = job?.JD_JobId;
            // const stages = job?.recruitment_json
            //   ? JSON.parse(job.recruitment_json)?.stages || []
            //   : [];

            const stages = job?.recruitment_details?.CandidateField?.stages
       
            return (
              <Grid
                item
                xs={12}
                key={index}
                sx={{
                  margin: "10px auto",
                  borderRadius: "10px",
                  padding: "15px",
                  border: job?.JA_Isdeployed
                    ? "2px solid #2E7D32" // dark green
                    : job?.JA_Cancellation
                      ? "2px solid #C62828" // dark red
                      : "1px solid #D0D0D0",
                  backgroundColor: job?.JA_Isdeployed
                    ? "#E8F5E9" // light green tint
                    : job?.JA_Cancellation
                      ? "#FDECEA" // light red tint
                      : "#FAFAFA",
                  color: "#1F2937", // neutral dark text
                }}
              >
                {/* Application Progress - Job Title */}
                <Typography
                  sx={{
                    px: 2,
                    textAlign: "left",
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "22px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  ({jobId}) - {jobTitle}{" "}

                  {job?.JA_Cancellation ? (
                    <Chip
                      label="Cancelled"
                      size="small"
                      sx={{
                        bgcolor: "#FDECEA",
                        fontSize: "18px",
                        color: "#B42318",
                        border: "1px solid #C62828",
                      }}
                    />
                  ) : job?.JA_Isdeployed ? (
                    <Chip
                      label="Deployed"
                      size="small"
                      sx={{
                        bgcolor: "#E8F5E9",
                        fontSize: "18px",
                        color: "#1B5E20",
                        border: "1px solid #2E7D32",
                      }}
                    />
                  ) : null}

                </Typography>

                {job?.JA_Cancellation && job?.JA_CancellationRemarks ? (
                  <Box
                    sx={{
                      mt: 2,
                      px: 2,
                      py: 1.2,
                      borderRadius: "8px",
                      backgroundColor: "#FFF5F5",
                      border: "1px solid #F5C2C7",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#B42318",
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      Cancellation Reason:
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#7A271A",
                        mt: 0.5,
                      }}
                    >
                      {job.JA_CancellationRemarks}
                    </Typography>
                  </Box>
                ) : null}

                {/* Horizontal Scrollable Box of Stages */}
              
                {!job?.JA_Cancellation ? (
                  <HorizontalStageBox stages={stages} />
                ) : null}
              </Grid>
            );
          }) : (
            <Box
              sx={{
                width:"100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px",
                textAlign: "center",
                color: "text.secondary",
                gap: 2,
                p: 3,
                bgcolor: "#f9f9f9",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <ErrorOutlineIcon sx={{ fontSize: 60, color: "action.disabled" }} />
              <Typography variant="h6" fontWeight={600}>
                No Data Found
              </Typography>

            </Box>)}
      </Grid>
    </Box>
  );
}

export default CandidateJobs;
